import { getStaticContentProps, withContent } from '@jerry-serverless/seo-next-ssg-helpers';

import { HomePageRoute } from './index';

/**
 * to inject the cookieBannerType prop into the page
 */

export default withContent(HomePageRoute);

export const getStaticProps = getStaticContentProps(
  {
    PageComponent: HomePageRoute,
    disableIsr: true,
  },
  async () => ({
    props: {
      cookieBannerType: 1,
    },
  })
);
